export const MIN_WIDTH = 7
